import { useEffect } from "react";
import { useConfig } from "../../hooks/useConfig";
import { termsSections } from "./termsSections";

export function TermsPage() {
  const { config } = useConfig();
  const sections = termsSections(config);

  useEffect(() => {
    document.title = "Terms | $TISM";
  }, []);

  return (
    <>
      <section className="shell section">
        <div className="stack stack-4">
          <p className="eyebrow">Terms</p>
          <h1>The plain version.</h1>
          <p className="lede">
            What $TISM is, what it is not, what is pledged, and who is behind it. Facts only.
          </p>
        </div>
      </section>

      <section className="shell" style={{ paddingBottom: "var(--section-y)" }}>
        <div className="stack stack-7">
          {sections.map((section) => (
            <div className="terms__section stack stack-4" key={section.id} id={section.id}>
              <h2>{section.title}</h2>
              <div className="stack stack-3">{section.body}</div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
